import { Link } from '@atlassian/amkt-common';
import React from 'react';
function AtlassianSupportsUkraineMessageBody() {
  return /*#__PURE__*/React.createElement("p", null, "Atlassian is winding down operations in Russia and Belarus. Starting November 21, 2022, we will no longer sell, support, or renew apps from Marketplace partners in these countries. Please raise a", ' ', /*#__PURE__*/React.createElement(Link, {
    target: "_blank",
    href: "https://support.atlassian.com/"
  }, "support ticket"), ' ', "for any questions or concerns.");
}
export const atlassianStandsWithUkraineMessage = {
  header: 'We stand with Ukraine',
  body: /*#__PURE__*/React.createElement(AtlassianSupportsUkraineMessageBody, null)
};